import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		gray: {
			700: '#1f2733'
		}
	},
	fonts: {
		heading: "'IRANSansX', 'Roboto', sans-serif",
		body: "'IRANSansX', 'Roboto', sans-serif",
	},
	styles: {
		global: (props) => ({
			body: {
				bg: mode('gray.50', 'gray.800')(props),
				fontFamily: "'IRANSansX', 'Roboto', sans-serif",
				direction: 'rtl',
				textAlign: 'right'
			},
			html: {
				fontFamily: "'IRANSansX', 'Roboto', sans-serif",
				direction: 'rtl',
				textAlign: 'right'
			},
			'*': {
				direction: 'rtl'
			},
			'h1, h2, h3, h4, h5, h6': {
				fontFamily: "'IRANSansX', 'Roboto', sans-serif",
				fontWeight: 'bold',
				textAlign: 'right',
				direction: 'rtl'
			},
			'.chakra-heading': {
				fontFamily: "'IRANSansX', 'Roboto', sans-serif",
				fontWeight: 'bold',
				textAlign: 'right',
				direction: 'rtl'
			},
			'input, textarea, select': {
				textAlign: 'right'
			},
			'.chakra-input, .chakra-textarea, .chakra-select': {
				textAlign: 'right'
			},
			'.chakra-modal__content': {
				direction: 'rtl'
			},
			'.chakra-toast': {
				direction: 'rtl',
				textAlign: 'right'
			},
			'.css-zj2dqk':{
    right: 'auto !important',
    left: '0.5rem !important'
},
'.css-1jj9yua':{
	left:'0 !important',
	right:'auto !important'
}
		})
	}
};
